import { DateTime } from 'luxon';
import { DurationUnit, ProductPrice, RentalProductPrice, RecurringType, CustomProductPricingConfig } from './pricing';
import { OrderType } from '../order/order';

export namespace PricingParsers {
  export type ProductPriceJson = RentalProductPriceJson | SaleProductPriceJson;

  export type RentalProductPriceJson = {
    readonly id: string;
    readonly productId: number;
    readonly type: OrderType.Rental;
    readonly price: number;
    readonly from: string | undefined;
    readonly to: string | undefined;
    readonly durationValue: number;
    readonly durationUnit: DurationUnit;
    readonly durationMinutes: number;
    readonly durationLabel: string | undefined;

    readonly recurringType: RecurringType | undefined;
    readonly recurringDaysOfWeek: number[] | undefined;
    readonly recurringWeeksOfMonth: number[] | undefined;
    readonly recurringDaysOfMonth: number[] | undefined;

    readonly name: string | undefined;
    readonly featured: boolean;
    readonly createdAt: string;
    readonly deletedAt: string | undefined;
    readonly locationIds: number[] | undefined;

    readonly orderId?: number;
    readonly userId?: number;
    readonly originalPrice?: RentalProductPriceJson;
  };

  export type SaleProductPriceJson = {
    readonly id: string;
    readonly productId: number;
    readonly type: OrderType.Sale;
    readonly price: number;
    readonly from: string | undefined;
    readonly to: string | undefined;
    readonly name: string | undefined;
    readonly featured: boolean;
    readonly createdAt: string;
    readonly deletedAt: string | undefined;
    readonly locationIds: number[] | undefined;
    readonly userId?: number;
  };

  export function toProductPrice(input: ProductPriceJson): ProductPrice {
    const res = {
      ...input,
      from: input.from ? DateTime.fromISO(input.from) : undefined,
      to: input.to ? DateTime.fromISO(input.to) : undefined,
      createdAt: DateTime.fromISO(input.createdAt),
      deletedAt: input.deletedAt ? DateTime.fromISO(input.deletedAt) : undefined,
    };
    if (res.type === OrderType.Rental) {
      return {
        ...res,
        originalPrice: res.originalPrice ? toProductPrice(res.originalPrice) : undefined,
      } as RentalProductPrice;
    } else {
      return res;
    }
  }

  export type CustomProductPricingConfigJson = {
    readonly id: string;
    readonly type: OrderType;
    readonly durationValue: number;
    readonly durationUnit: DurationUnit;
    readonly createdAt: string;
    readonly updatedAt: string;
  };

  export function toCustomProductPricingConfig(input: CustomProductPricingConfigJson): CustomProductPricingConfig {
    return {
      ...input,
      createdAt: DateTime.fromISO(input.createdAt),
      updatedAt: DateTime.fromISO(input.updatedAt),
    };
  }
}
